
<template>
  <div style="border: 0px solid black; width:100%;display:block;">
    <div class="welcome" style="border: 0px solid red;display: inline-block;   ">
      <row style="border:0px solid green;display: table-cell;width:100%;">
        <div
          style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
        >
          <b>{{$t('customer.companylist')}}</b>

          <lte-button
            style="float:right;"
            type="btn
                            btn-primary"
            right_icon="fa
                            fa-plus"
            @click="callback($event)"
          >{{$t('customer.addnew')}}</lte-button>

          <lte-button v-show="false"
            style="float:right;"
            type="btn
                            btn-primary"
            right_icon="fa
                            fa-download"
            @click="onExport($event)"
          >{{$t('customer.export')}}</lte-button>

          <!-- <download-excel
            class="btn btn-primary"
            style="float: right; font-size: 14px;
                                                 font-family: arail;
                                                 cursor: pointer;
                                                 margin: 1px;"
            :data="json_data_cutomer"
            :fields="json_fields_customer"
            worksheet="Customer"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            name="filename.xls"
          >
            <i class="fa fa-download"></i>
            <span>Export Excel</span>
          </download-excel>-->
          <lte-button v-show="false"
            style="float:right;"
            type="btn
                            btn-primary"
            right_icon="fa
                            fa-plus"
            @click="importExcel($event)"
          >{{$t('customer.importExcel')}}</lte-button>
        </div>
        <!-- <div class="box box-success" >
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('search.title')}}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-building"></i></span>
                  <input type="text" class="form-control" :placeholder="$t('customer.company_name')" v-model="search.company_name">
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-dot-circle-o"></i></span>
                  <input type="text" class="form-control" :placeholder="$t('customer.company_address')" v-model="search.company_address">
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input type="text" class="form-control" :placeholder="$t('customer.company_tax_code')" v-model="search.company_tax_code">
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                  <input type="text" class="form-control" :placeholder="$t('customer.company_email')" v-model="search.company_email">
                </div>
              </div>
            </div>

            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-mobile"></i></span>
                  <input type="text" class="form-control" :placeholder="$t('customer.company_phone')" v-model="search.company_phone">
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-globe"></i></span>
                  <input type="text" class="form-control" :placeholder="$t('customer.company_website')" v-model="search.company_website">
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCompany"
                  >
                  <span class="btn-label">
                  <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
              </div>
            </div>
          </div>
        </div> -->
        <lte-table
          :hdBackground="hdBackground"
          :data="gridCustomerDataList"
          :columns="gridColumns"
          search_filter="left-search"
          @actions="crudActions"
          :actions="actions"
          :useFilter = "useFilter"
        ></lte-table>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :item="paginatorItem"
            @onpaginate="onPagination"
          />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import JsonExcel from "vue-json-excel";
import XLSX from "xlsx";
import Paginator from "@/components/Paginator.vue"
import utils from '@/lib/utils'

export default {
  name: "CompanyList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      groupUserID: 4,
      gridCustomerDataList: [],
      useFilter:false,
      gridColumns: [
        "common.nonumber",
        // "common.code",
        "customer.company_name",
        "customer.company_address",
        "customer.company_tax_code",
        "customer.company_email",
        "customer.company_phone",
        "customer.company_website"
      ],
      actions: ["common.modify", "common.delete"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],

      json_data_cutomer: [],
      json_fields_customer: {
        UserID: "username",
        Password: "password",
        Họ: "last_name",
        Tên: "first_name",
        Email: "email",
        "Ngày Sinh": "profile.dob",
        "Điện Thoại": "profile.phone",
        "Giới Tính": "profile.gender",
        "CRM Code": "profile.customer_crm_code",
        "Quốc Gia": "profile.country"
      },

      Datas: {
        // We will make a Workbook contains 2 Worksheets
        customers: [
          { name: "cat", category: "animal" },
          { name: "dog", category: "animal" },
          { name: "pig", category: "animal" }
        ],
        pokemons: [
          { name: "pikachu", category: "pokemon" },
          { name: "Arbok", category: "pokemon" },
          { name: "Eevee", category: "pokemon" }
        ]
      },
      paginatorItem: {
        commit_function: "GET_CUSTOMER_LIST"
      },
      search: {
        company_name: "",
        company_address: "",
        company_tax_code: "",
        company_email: "",
        company_phone: "",
        company_website: ""
      }
    };
  },
  watch: {
    GET_CUSTOMER_DATA: function() {
      this.gridCustomerDataList = [];
      this.GET_CUSTOMER_DATA.forEach( (customer, i) => {
        let nonumber = (i + 1) + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = customer.code;
        let company_name = customer.profile.company_name;
        let company_address = customer.profile.company_address;
        let company_tax_code = customer.profile.company_tax_code;
        let company_email = customer.profile.company_email;
        let company_phone = customer.profile.company_phone;
        let company_website = customer.profile.company_website;

        let id = customer.id;
        // let fullname = `${customer.firstname} ${customer.lastname}`;
        //let firstname = customer.firstname
        //let lastname  = customer.lastname
        // let lastlogin = customer.lastlogin;
        // let email = customer.email;
        //let age       = customer.age
        // let phone = customer.phone;
        // let gender = customer.gender == 0 ? "Female" : "Male";
        // let crmcode = customer.crmcode;
        // let country = customer.country;

        // let group = customer.groups[0];
        // let group_name = this.getGroupname(group);

        // let privilege = customer.privilege.length > 0 ? customer.privilege[0].privilege_name : "";
        let data = {
          "common.nonumber": nonumber,
          "common.code": code,
          "customer.company_name": company_name,
          "customer.company_address": company_address,
          "customer.company_tax_code": company_tax_code,
          "customer.company_email": company_email,
          "customer.company_phone": company_phone,
          "customer.company_website": company_website,

          // "customer.crmcode": crmcode,
          // "customer.privilege": `${group_name}/${privilege}`,
          // "customer.country": country,
          "customer.is_company":customer.is_company,
          id: id
        };
        this.gridCustomerDataList.push(data);
      });

      return this.gridCustomerDataList;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_CUSTOMER_DATA"
    ])
  },

  methods: {
    onSearchCompany: function() {
      // const data = {
      //   params: {
      //     page: 1,
      //     company_name: this.search.company_name,
      //     company_address: this.search.company_address,
      //     company_tax_code: this.search.company_tax_code,
      //     company_email: this.search.company_email,
      //     company_phone: this.search.company_phone,
      //     company_website: this.search.company_website,
      //   }
      // }
      //this.GET_CUSTOMER_LIST(data)
    },
    getGroupname(id) {
      if (id === 1) {
        return "Admin"
      } else if (id === 2) {
        return "Mod"
      } else if (id === 3) {
        return "Staff"
      } else if (id === 4) {
        return "Customer"
      } else if (id === 5) {
        return "Operator"
      }
      return id
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    callback: function() {
      this.$router.push({
        name: "CustomerAdd",
        params: {
          id: 0
        },
        query: {
            is_company: true,
            callback: "CompanyList"
          }
      });
    },
    onExport: async function() {
      try {
        const cust_filter = {
          params: {
            is_company:true
          }
        };
        await this.GET_CUSTOMER_LIST(cust_filter).then(
          function(res) {
            let result = res.data;
            result.results.forEach(v => {
              let json_data = {
                UserID: v.username,
                Password: "", //v.password
                Họ: v.last_name,
                Tên: v.first_name,
                Email: v.email,
                "Ngày Sinh": utils.formatSqlDate(v.profile.dob, null, "DD/MM/YYYY", ""),
                "Điện Thoại": v.profile.phone,
                "Giới Tính": v.profile.gender == 1 ? "Nam" : "Nữ",
                "CRM Code": v.profile.customer_crm_code,
                "Quốc Gia": v.profile.country_name
              };
              this.json_data_cutomer.push(json_data);
            });
          }.bind(this)
        );
      } catch (error) {
        /*
         * 'error' is corresponding with 'xhr.statusText'
         * from either 'https://something.com' or 'https://other.com'
         */
      }

      // export json to Worksheet of Excel
      // only array possible
      var customers = XLSX.utils.json_to_sheet(this.json_data_cutomer);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, customers, "Customers"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "Customers.xlsx"); // name of the file is 'book.xlsx'
    },
    importExcel: function() {
      this.$router.push({
        name: "CustomerImportExcel",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "CustomerAdd",
          params: {
            id: recordData.id
          },
          query: {
              is_company: recordData['customer.is_company'],
              callback: "CompanyList"
            }
        });
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    // https://completejavascript.com/xu-ly-bat-dong-bo-callback-promise-async-await/
    async startDownload() {
      try {
        await this.GET_CUSTOMER_LIST().then(
          function(res) {
            let result = res.data;
            result.results.forEach(v => {
              this.json_data_cutomer.push(v);
            });
          }.bind(this)
        );
      } catch (error) {
        /*
         * 'error' is corresponding with 'xhr.statusText'
         * from either 'https://something.com' or 'https://other.com'
         */
      }
    },
    finishDownload() {
      //console.log("finishDownload");
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_CUSTOMER(this.originalRecordData)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridCustomerDataList.length == 1
                ? totalPage - 1
                : currentPage;
            const data = {
              params: {
                page: page
              }
            };
            this.GET_CUSTOMER_LIST(data);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_CUSTOMER_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_CUSTOMER_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      const filter = {
        params: {
          page: data.params.page,
          is_company:true
        }
      };
      this.GET_CUSTOMER_LIST(filter);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_CUSTOMER_LIST",
      "DELETE_CUSTOMER"
    ])
  },
  mounted() {
    const data = {
      params: {
        page: 1,
        is_company:true
      }
    };
    this.GET_CUSTOMER_LIST(data);
  },

  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    // downloadExcel: JsonExcel,
    'paginator': Paginator
  }
};
</script>












// WEBPACK FOOTER //
// src/views/Customer/CompanyList.vue